import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TUserClient, TUserClientBodyRequest, TUserClientResponse, adaptUserClientFromResponse, adaptUserClientToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_USER_CLIENT } from '../../backend-paths';


export const userClientCreateApi = createAsyncThunk(
	`POST/${BACKEND_USER_CLIENT}`,
	(payload: TUserClientBodyRequest, thunkApi) => {
		const dataRequest = adaptUserClientToRequest(payload);

		return HttpService.post<TUserClientResponse>(BACKEND_USER_CLIENT, dataRequest).then(result => {
			return adaptUserClientFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TUserClient> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const userClientCreateSlice = createSlice({
	name: 'userClientCreateSlice',
	initialState,
	reducers: {
		clearUserClientCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[userClientCreateApi.pending.type]: (state) => {
			state.error = undefined;
			state.isLoading = true;
		},

		[userClientCreateApi.fulfilled.type]: (state, action: PayloadAction<TUserClient>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[userClientCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const useUserClientCreateSelector = () => useAppSelector(state => state[userClientCreateSlice.name]);

export const { clearUserClientCreate } = userClientCreateSlice.actions;
